import React, { useState, useEffect } from 'react';
import { Table, Button, Space, Modal, Form, Input, Tag, message } from 'antd';
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { modalidadeService } from '../services/api';

const ModalidadesList = () => {
  const [modalidades, setModalidades] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [form] = Form.useForm();

  useEffect(() => {
    fetchModalidades();
  }, []);

  const fetchModalidades = async () => {
    setLoading(true);
    try {
      const response = await modalidadeService.list();
      setModalidades(response.data);
    } catch (error) {
      message.error('Erro ao carregar modalidades');
      console.error(error);
    }
    setLoading(false);
  };

  const handleAdd = () => {
    form.resetFields();
    setEditingId(null);
    setIsModalVisible(true);
  };

  const handleEdit = (record) => {
    setEditingId(record.id);
    form.setFieldsValue(record);
    setIsModalVisible(true);
  };

  const handleDelete = async (id) => {
    Modal.confirm({
      title: 'Confirmação',
      content: 'Deseja excluir esta modalidade?',
      okText: 'Sim',
      cancelText: 'Não',
      okButtonProps: { danger: true },
      onOk: async () => {
        try {
          await modalidadeService.delete(id);
          message.success('Modalidade excluída com sucesso');
          fetchModalidades();
        } catch (error) {
          message.error('Erro ao excluir modalidade');
        }
      },
    });
  };

  const handleSubmit = async (values) => {
    try {
      if (editingId) {
        await modalidadeService.update(editingId, values);
        message.success('Modalidade atualizada com sucesso');
      } else {
        await modalidadeService.create(values);
        message.success('Modalidade criada com sucesso');
      }
      setIsModalVisible(false);
      fetchModalidades();
    } catch (error) {
      message.error('Erro ao salvar modalidade');
      console.error(error);
    }
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 50,
    },
    {
      title: 'Nome da Modalidade',
      dataIndex: 'nome_modalidade',
      key: 'nome_modalidade',
    },
    {
      title: 'Ações',
      key: 'actions',
      width: 100,
      render: (_, record) => (
        <Space>
          <Button
            icon={<EditOutlined />}
            onClick={() => handleEdit(record)}
            size="small"
          />
          <Button
            icon={<DeleteOutlined />}
            danger
            onClick={() => handleDelete(record.id)}
            size="small"
          />
        </Space>
      ),
    },
  ];

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <Button type="primary" icon={<PlusOutlined />} onClick={handleAdd}>
          Nova Modalidade
        </Button>
      </div>

      <Table
        columns={columns}
        dataSource={modalidades}
        loading={loading}
        rowKey="id"
        pagination={{ pageSize: 10 }}
        scroll={{ x: 800 }}
      />

      <Modal
        title={editingId ? 'Editar Modalidade' : 'Nova Modalidade'}
        open={isModalVisible}
        onOk={() => form.submit()}
        onCancel={() => setIsModalVisible(false)}
        width={500}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
        >
          <Form.Item
            name="nome_modalidade"
            label="Nome da Modalidade"
            rules={[{ required: true, message: 'Nome é obrigatório' }]}
          >
            <Input placeholder="Ex: Ballet, Circo, Patins..." />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default ModalidadesList;
